<template>
    <fragment>
        <div class="login-page">
            <div class="form">
                <form class="login-form" @submit.prevent>
                    <dl class="notice_msg">
                        <dt>
                            <!-- Service Knowledge Portal -->
                            <img src="/static/images/logo.png" alt="Service Knowledge Portal">
                        </dt>
                        <dd>
                            Request for <span>Authorization</span>
                        </dd>
                    </dl>
                    <p class="message">User Name</p>
                    <input type="text" name="userName" readonly v-model="userName" />
                    <p class="message">Level</p>
                    <select id="deptLevelCd" name="deptLevelCd" v-model="deptLevelCd">
                        <option v-if="!loginSystem.length" disabled value="">Select</option>
                        <option value="1" v-if="loginSystem.length && (loginSystem === getLoginSysApprovalGSPN || loginSystem === getLoginSysSupport)">ASC/CC</option>
                        <option value="2" v-if="loginSystem.length && (loginSystem === getLoginSysSCMS         || loginSystem === getLoginSysApprovalCS)">Subsidiary</option>
                        <option value="3" v-if="loginSystem.length && deptLevelCd === 3">RHQ</option>
                        <option value="4" v-if="loginSystem.length && deptLevelCd === 4">GBM</option>
                    </select>
                    <template v-if="deptLevelCd > 3">
                        <p class="message">GBM</p>
                        <select id="gbmCd" name="gbmCd" v-model="gbmCd">
                            <option disabled value="">Select</option>
                        </select>
                    </template>
                    <template v-if="deptLevelCd < 4">
                        <p class="message">RHQ</p>
                        <select id="rhqCd" name="rhqCd" v-model="rhqCd" @change="changeRhqCd($event)">
                            <option v-if="rhqCd !== ''" :value="rhqCd">{{ rhqNm }}</option>
                            <option v-else disabled value="">Select</option>
                        </select>
                    </template>
                    <template v-if="deptLevelCd < 3">
                        <p class="message">Subsidiary</p>
                        <select id="companyCode" name="companyCode" v-model="companyCode">
                            <option v-if="companyCode === '' || companyCode === null" disabled value="">Select</option>
                            <option v-for="(item, index) in companyCodeList"
                                    :key="item.code"
                                    :value="item.code"
                            >{{item.codeName}}</option>
                        </select>
                    </template>
                    <button type="submit" @click="handleSubmit">Save</button>
                </form>
            </div>
        </div>
    </fragment>
</template>
<script>
import Vue                                              from 'vue';
import axios                                            from 'axios';
import qs                                               from 'query-string';
import moment                                           from 'moment';
import { mapActions, mapGetters }                       from 'vuex';
import { SDLUtil, MenuUtil, StringUtil, GSPNCryptor }   from '@/utils';
import api                                              from '@/service';
import store                                            from '@/vuex/store';
import constants                                        from '@/constants';
import loginService                                     from '@/service/skpLoginService';

export default {
    name: 'RequestForAuth',
    data() {
        return {
            deptLevelCd: '',

            userId: '',
            companyCode: '',
            companyCodeList: [],
            accountNo: '',
            userName: '',
            employeeNo: '',
            email: '',
            phoneNo: '',
            mobileNo: '',
            partnerType: '',

            language: '',
            dateFormat: '',
            timeFormat: '',
            timeZone: '',
            listLineNo: '',

            topMenuType: '',
            loadMenuKind: '',
            loginSystem: '',

            gbmCd: '',
            gbmList: [],
            rhqCd: '',
            rhqNm: '',

            errorState: { code: '', msg: '' }
        };
    },
    computed: {
        ...mapGetters({
            connSystem: 'getConnSystem',
            regParams: 'getRegParams',
        }),
        getLoginSysApprovalCS()     { return `${constants.LOGIN_SYS_APPROVAL_CS}`; },     // WLDPTM
        getLoginSysApprovalGSPN()   { return `${constants.LOGIN_SYS_APPROVAL_GSPN}`; },   // VLDPS
        getLoginSysSCMS()           { return `${constants.LOGIN_SYS_SCMS}`; },            // SCMS
        getLoginSysSupport()        { return `${constants.LOGIN_SYS_SUPPORT}`; },         // SUPPORT
        getLoadMenuAll()            { return `${constants.SYSTEM_LOAD_MENU_ALL}`; },      // ALL
        getLoadMenuSup()            { return `${constants.SYSTEM_LOAD_MENU_SUP}`; },      // SUP

    },
    methods: {
        initLoad() {
            this.loginSystem    = StringUtil.nvl(this.regParams.loginSystem);
            this.userId         = StringUtil.nvl(this.regParams.loginId);
            this.userName       = StringUtil.nvl(this.regParams.loginName, this.regParams.loginId);
            this.companyCode    = StringUtil.nvl(this.regParams.loginCorp);
            this.rhqCd          = StringUtil.nvl(this.regParams.loginRHQ);
            this.rhqNm          = StringUtil.nvl(this.regParams.loginRHQNm);
            this.accountNo      = StringUtil.nvl(this.regParams.accountNo);
            this.email          = StringUtil.nvl(this.regParams.email);
            this.phoneNo        = StringUtil.nvl(this.regParams.phoneNo);
            this.mobileNo       = StringUtil.nvl(this.regParams.mobileNo);
            this.partnerType    = StringUtil.nvl(this.regParams.partnerType);

            this.language       = StringUtil.nvl(this.regParams.language, 'en');
            this.timeFormat     = StringUtil.nvl(this.regParams.timeFormat, 'a_hh@mm@ss');
            this.dateFormat     = StringUtil.nvl(this.regParams.dateFormat, 'MM.dd.yyyy');
            this.timeZone       = StringUtil.nvl(this.regParams.timeZone, 'Asia/Seoul');
            this.listLineNo     = StringUtil.nvl(this.regParams.listLineNo, '10');

            this.topMenuType    = StringUtil.nvl(this.regParams.topMenuType, 1);
            this.loadMenuKind   = StringUtil.nvl(this.regParams.loadMenuKind);
            this.loginSystem    = StringUtil.nvl(this.regParams.loginSystem);

            // 시스템에 따른 권한 설정
            switch ( this.loginSystem ) {
                case this.getLoginSysApprovalGSPN:
                    this.deptLevelCd = 1;
                    break;

                case this.getLoginSysSupport:
                    this.deptLevelCd = 1;
                    break;

                case this.getLoginSysSCMS:
                    this.deptLevelCd = 2;
                    break;

                case this.getLoginSysApprovalCS:
                    this.deptLevelCd = 2;
                    break;

                default:
                    // TODO 시스템 코드가 없을 경우
                    this.deptLevelCd = 1;
                    break;
            };

            this.setCorpList();

            // 등록 시 사용한 파라미터 초기화
            store.commit('REG_PARAMS', {});
        },

        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            let additionalValue = (['RHQ_AUTH_ACCESS_CD', 'SUB_AUTH_ACCESS_CD'].includes(categoryCode)) ? this.getLoginNo : this.getUserCorpCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, additionalValue);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.subsidiaryList = [], this.subsidiaryCd = '';

            } else {
                this.getCodeComboList(comboValue, "SAP_COMPANY_CD").then(data => {
                    this.companyCodeList = data;

                    let that = this;
                    if(this.deptLevelCd < 3) {
                        this.companyCodeList = this.companyCodeList.filter(function(c) { return c.code === that.companyCode; });
                    }
                });
            }
        },
        setCorpList() {
            this.getCodeComboList(this.rhqCd, "SAP_COMPANY_CD")
                .then(data => {
                    this.companyCodeList = data;

                    let that = this;
                    if(this.deptLevelCd < 3) {
                        this.companyCodeList = this.companyCodeList.filter(function(c) { return c.code === that.companyCode; });
                    }
                });
        },

        async handleSubmit() {
            SDLUtil.showLoadingBar(true);
            const procTime = moment().format('YYMMDDHHmm');
            const params = {
                    userId:          await  GSPNCryptor.encrypt(procTime + this.userId),
                    companyCode:     await  GSPNCryptor.encrypt(this.companyCode),
                    accountNo:       await  GSPNCryptor.encrypt(this.accountNo),
                    userName:        await  GSPNCryptor.encrypt(this.userName),
                    employeeNo:      await  GSPNCryptor.encrypt(this.employeeNo),
                    email:           await  GSPNCryptor.encrypt(this.email),
                    phoneNo:         await  GSPNCryptor.encrypt(this.phoneNo),
                    mobileNo:        await  GSPNCryptor.encrypt(this.mobileNo),
                    partnerType:     await  GSPNCryptor.encrypt(this.partnerType),
                    deptLevelCd:    this.deptLevelCd,
                    gbmCd:          this.gbm,
                    rhqCd:          this.rhqCd,
                    subsidiaryCd:   this.companyCode,

                    language:       this.language,
                    dateFormat:     this.dateFormat,
                    timeFormat:     this.timeFormat,
                    timeZone:       this.timeZone,
                    listLineNo:     this.listLineNo,
                    topMenuType:    this.topMenuType,
                    loadMenuKind:   this.loadMenuKind,
                    loginSystem:    this.loginSystem,
                };

            return axios.post(
                    `${SDLUtil.API_URL}/noauth/login/saveRequestForAuth.skp`,
                    qs.stringify(params),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    Vue.$log.info("▶ RequestForAuth.vue saveRequestForAuth response =>", res);
                    store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                        if(isAuth) {
                            this.gotoMain();

                        } else {
                            Vue.$log.error('▶ RequestForAuth.vue Login error', isAuth);
                            alert("No register login user. This system is not available.");
                            this.$router.push({ path: '/no_auth' }); // 추후 수정
                        }
                    });
                })
                .catch(err => {
                    Vue.$log.error('▶ RequestForAuth.vue Login error', err);
                    alert("No register login user. This system is not available.");
                    this.$router.push({ path: '/no_auth' }); // 추후 수정
                });
        },
        afterLoginProcess(loginResult = false) {
            SDLUtil.showLoadingBar(false);
            if (loginResult) {
                this.gotoMain();

            } else {
                this.$log.warn('▶ RequestForAuth.vue afterLoginProcess error');
                return SDLUtil.alert({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.AUTH.PWD.NOTMATCH',
                    okLabel: 'BUTTON.GLOBAL.OK',
                });
            }
        },
        gotoMain() {
            if (this.loadMenuKind === this.getLoadMenuSup) {
                this.$router.push(MenuUtil.getSupportMain());
            } else {
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/main` });
            }
        },
    },
    created() {
        Vue.$log.info('▶ RequestForAuth.vue created.', this.regParams);
        this.initLoad();
    },
    mounted() {
        Vue.$log.info('▶ RequestForAuth.vue mounted.');
    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>
<style scoped>
    @import url(https://fonts.googleapis.com/css?family=Roboto:300);

    .login-page {
        width: 360px;
        padding: 8% 0 0;
        margin: auto;
    }
    .form {
        position: relative;
        z-index: 1;
        background: #ffffff;
        max-width: 360px;
        margin: 0 auto 100px;
        padding: 45px;
        text-align: center;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
    }
    .form select {
        font-family: 'Roboto', sans-serif;
        outline: 0;
        background: #f2f2f2;
        width: 100%;
        border: 0;
        margin: 0 0 15px;
        height: 47px;
        line-height: normal;
        padding: 15px !important;
        box-sizing: border-box;
        font-size: 14px;
    }
    .form input {
        font-family: 'Roboto', sans-serif;
        outline: 0;
        background: #f2f2f2;
        width: 100%;
        border: 0;
        margin: 0 0 15px;
        padding: 15px;
        box-sizing: border-box;
        font-size: 14px;
    }
    .form button {
        font-family: 'Roboto', sans-serif;
        text-transform: uppercase;
        outline: 0;
        background: #014bb4;
        width: 100%;
        border: 0;
        padding: 15px;
        color: #ffffff;
        font-size: 18px;
        font-weight: 700;
        -webkit-transition: all 0.3 ease;
        transition: all 0.3 ease;
        cursor: pointer;
    }
    .form .message {
        margin: 0 0 5px 0;
        color: #b3b3b3;
        font-size: 12px;
    }
    .form .message a {
        color: #4caf50;
        text-decoration: none;
    }
    .form button:hover,
    .form button:active,
    .form button:focus {
        background: #808080;
    }
    body {
        background: #76b852; /* fallback for old browsers */
        background: -webkit-linear-gradient(right, #76b852, #8dc26f);
        background: -moz-linear-gradient(right, #76b852, #8dc26f);
        background: -o-linear-gradient(right, #76b852, #8dc26f);
        background: linear-gradient(to left, #76b852, #8dc26f);
        font-family: 'Roboto', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    /* 200618추가 */
    dl.notice_msg {
        display:block;
        margin-bottom:15px;
        text-align:center;
        padding:5px;
        border-bottom:1px solid #eee;
        background-color:#014bb4;
    }
    dl.notice_msg dt {font-size:14px;color:red;font-weight:bold;}
    dl.notice_msg dd {font-size:14px;line-height:20px;padding-top:5px;color:#fff;}
    dl.notice_msg dd span {font-weight: bold;}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/login/RequestForAuth.vue